import { card } from './components/card';
import { button } from './components/button';
import { tabs } from './components/tabs';
import { breadcrumb } from './components/breadcrumb';
import { panel } from './components/panel';
import { multiselect } from './components/multiselect';
import { toolbar } from './components/toolbar';
import { radiobutton } from './components/radiobutton';
import { fileupload } from './components/fileupload';
import { datatable } from './components/datatable';
import { textarea } from './components/textarea';

export const components = {
  card,
  button,
  tabs,
  breadcrumb,
  panel,
  multiselect,
  toolbar,
  radiobutton,
  fileupload,
  datatable,
  textarea,
};
